import Api from '@/services/api.js';

export default {
  addTipSpoil(details) {
    return Api.post('tipSpoils/', details);
  },
  getAllTipSpoils() {
    return Api.get('tipSpoils/');
  },
  deleteTipSpoil(tipSpoil) {
    return Api.delete(`tipSpoils/${tipSpoil}`);
  },
  updateTipSpoil(tipSpoil) {
    var tipSpoilId = tipSpoil.id;
    return Api.put(`tipSpoils/${tipSpoilId}`, tipSpoil);
  },
  getTipSpoilsById(id, type) {
    if (type == 'tip') {
      return this.getTipSpoilsByTip(id)
    } else {
      return this.getTipSpoilsBySpoil(id)
    }
  },
  getTipSpoilsByTip(id) {
    return Api.get('tipSpoils/byTip/' + id);
  },
  getTipSpoilsBySpoil(id) {
    return Api.get('tipSpoils/bySpoil/' + id);
  },
}